import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { common } from '@ocean/ui'

const { getTypography } = common

export const BigCalendarWrapper = styled.div`
  .rbc-calendar {
    height: 1500px;
  }

  .rbc-today {
    background: none;
  }

  .rbc-day-slot .rbc-events-container {
    margin-right: 0;
    overflow: hidden;
  }

  .rbc-allday-cell {
    display: none;
  }

  .rbc-time-view,
  .rbc-time-view .rbc-header,
  .rbc-time-header-content > .rbc-row.rbc-row-resource {
    border-bottom: 0;
  }

  .rbc-time-content,
  .rbc-row.rbc-time-header-cell {
    border-top-width: 1px;
    border-top-style: solid;
  }

  ${({ theme }) => `
    font-family: ${theme.fontFamily.secondary};
    font-size: ${theme.fontSize.mobile.small};
    line-height: ${theme.lineHeight.mobile.small};

    .rbc-time-view,
    .rbc-header,
    .rbc-time-header-content,
    .rbc-time-header-content > .rbc-row.rbc-row-resource,
    .rbc-time-content,
    .rbc-time-view-resources .rbc-time-gutter,
    .rbc-time-view-resources .rbc-time-header-gutter,
    .rbc-time-column .rbc-timeslot-group,
    .rbc-time-content > * + * > *,
    .rbc-day-bg + .rbc-day-bg,
    .rbc-row.rbc-time-header-cell,
    .rbc-month-view,
    .rbc-month-row + .rbc-month-row {
      border-color: ${theme.color.gallery};
    }

    .rbc-off-range-bg {
      background: ${theme.color.haze};
    }

    .rbc-day-slot .gapSlot {
      position: relative;
    }

    .rbc-day-slot .gapSlot:after {
      content: '';
      position: absolute;
      left: 1px;
      right: 2px;
      top: -1px;
      bottom: -1px;
      background: ${theme.color.gallery};
      ${theme.pattern}
      background-size: 63px;
    }

    .rbc-header {
      padding: ${theme.space.mobile.nano};
      font-size: 100%;
    }

    .rbc-time-header .rbc-row-resource .rbc-header {
      padding: ${theme.space.mobile.tiny};
      ${getTypography({ theme, variant: 'small', device: 'mobile' })}
      font-family: ${theme.fontFamily.secondary};
      font-weight: ${theme.fontWeight.normal};
    }

    .rbc-time-slot .rbc-label {
      color: ${theme.color.grey};
    }

    .rbc-month-view .rbc-event,
    .rbc-time-view .rbc-event {
      border-radius: 0;
      color: ${theme.color.white};
      padding: ${theme.space.mobile.tiny};
      border: 2px solid ${theme.color.white};
      background: ${theme.color.oceanDark};
      color: ${theme.color.white};

      &:focus {
        outline: 0;
      }

      &.upcoming {
        background: ${theme.color.oceanDark};
        color: ${theme.color.white};
      }

      &.current {
        background: ${theme.color.greenLight};
        color: ${theme.color.black};
      }

      &.ongoing {
        background: ${theme.color.danger} !important;
        color: ${theme.color.white} !important;
      }

      &.past, &.inactive {
        background: ${theme.color.haze} !important;
        color: ${theme.color.black} !important;
      }

      .rbc-event-label {
        font-size: ${theme.fontSize.mobile.tiny};
        line-height: ${theme.lineHeight.mobile.base};
      }

      .rbc-event-content {
        ${getTypography({ theme, variant: 'small', device: 'mobile' })}
        font-weight: ${theme.fontWeight.bold};
      }

      &:not(.draggable) { 
        cursor: default;
        opacity: .8;
      }
    }

    .rbc-addons-dnd {
      .rbc-addons-dnd-resize-ns-anchor:first-child {
        top: calc(-${theme.space.mobile.nano} - 1px);
      }

      .rbc-addons-dnd-resize-ns-anchor:last-child {
        bottom: calc(-${theme.space.mobile.nano} - 1px);
      }

      .rbc-addons-dnd-resize-ew-anchor:first-child {
        left: calc(-${theme.space.mobile.nano} - 1px);
      }

      .rbc-addons-dnd-resize-ew-anchor:last-child {
        right: calc(-${theme.space.mobile.nano} - 1px);
      }
    }

    .rbc-show-more {
      ${getTypography({ theme, variant: 'small', device: 'mobile' })}
      color: ${theme.color.ocean};
      transition: color 0.3s ease;

      &:hover {
        color: ${theme.color.oceanDark};
      }
    }
  `}

  ${({ theme }) => media.sm`
    .rbc-calendar {
      height: 1800px;
    }

    .rbc-time-header .rbc-row-resource .rbc-header {
      ${getTypography({ theme, variant: 'small', device: 'desktop' })}
      padding: ${theme.space.desktop.tiny};
    }

    .rbc-event .rbc-event-content {
      ${getTypography({ theme, variant: 'small', device: 'desktop' })}
    }
  `}
`
